export const background = {
    backgroundColor: "rgba(0,0,255,0.7)",
    width: "100vw",
    minHeight: "100vh",
    padding: "3%"
};

export const white = {
    backgroundColor: "white"
};
